import React from 'react';
import styled from 'styled-components';
import BodyStyles from './BodyStyles';
import Helmet from 'react-helmet';

const Styles = styled.div`
  .outter-content {
    text-align: center;
  }
`;

const Home = () => (
  <div>
    <Helmet>
      <title>Dennis Richard - Software Engineer</title>
      <meta
        name='description'
        content="Hi I'm Dennis, a software engineer. I can help you build your dream website."
      />
    </Helmet>
    <BodyStyles>
      <Styles>
        <div className='outter-content'>
          <h1>Hi, I'm Dennis</h1>
          <p>Software Engineer</p>
        </div>
      </Styles>
    </BodyStyles>
  </div>
);

export default Home;
